module.exports = __webpack_public_path__ + "static/meeting-2-11a2f3637a7421e60a54136228578e6a.png";